module.exports = __webpack_public_path__ + "img/blue_bc.a35d5413.jpg";